module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifiction-bell-point"
  }, [_c('span', {
    class: {
      'notifiction-bell-point__text-align': true,
      'notifiction-bell-point__text-align__color': _vm.newNotificationCount > 0
    },
    on: {
      "click": _vm.showNotificationsClickEvent
    }
  }, [_vm._v("\n    " + _vm._s(_vm.newNotificationCount) + "\n  ")]), _vm._v(" "), _c('span', {
    staticClass: "notifiction-bell-point__bell-dot",
    on: {
      "click": _vm.showNotificationsClickEvent
    }
  }, [_c('icon', {
    staticClass: "notifiction-bell-point__bell-outline",
    attrs: {
      "name": "bell",
      "scale": "1.3"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-609d42ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/notifications/NotificationsBellPoint.vue
// module id = 1906
// module chunks = 0